import { j as t } from "../../../../node_modules/react/jsx-runtime.js";
import { useState as f } from "react";
import E from "../../../../node_modules/lodash/uniqueId.js";
import { clsx as H } from "../../../../node_modules/clsx/dist/clsx.m.js";
import { Typography as R } from "../../Typography/Typography.js";
import { FieldLabel as S } from "../components/FieldLabel/FieldLabel.js";
import p from "./styles.module.scss.js";
import { FieldContainer as b } from "../TextField.js";
import k from "../components/FieldHelperText/FieldHelperText.js";
const P = ({
  label: o,
  optionalLabel: u,
  required: n,
  labelIconTooltip: j,
  helperTextIcon: s,
  helperTextIconTooltip: F,
  placeholder: v,
  value: a,
  helperText: l = "",
  disabled: e = !1,
  height: T,
  maxLength: r,
  testId: g,
  size: m = "regular",
  status: x,
  resizable: h,
  id: y,
  autoComplete: N = "off",
  readOnly: w = !1,
  onChange: i
}) => {
  const [A, I] = f(""), [$] = f(() => E("")), d = y || $, q = (c) => {
    I(c.target.value), i == null || i(c.target.value);
  };
  return /* @__PURE__ */ t.jsxs(
    b,
    {
      disabled: e,
      size: m,
      children: [
        o && /* @__PURE__ */ t.jsx(
          S,
          {
            label: o,
            optionalLabel: u,
            required: n,
            disabled: e,
            tooltipText: j,
            size: m,
            htmlFor: d,
            withTextField: !0
          }
        ),
        /* @__PURE__ */ t.jsxs("div", { className: "relative", children: [
          !!r && /* @__PURE__ */ t.jsx("div", { className: "absolute bottom-200 right-200", children: /* @__PURE__ */ t.jsx(
            R,
            {
              text: `${A.length}/${r}`,
              variant: "interface/medium/sm",
              textColor: "color/fg/lightest"
            }
          ) }),
          /* @__PURE__ */ t.jsx(
            "textarea",
            {
              placeholder: v,
              value: a,
              id: d,
              onChange: q,
              disabled: e,
              "data-testid": g,
              className: H(p.textArea, {
                "!resize": h,
                [p.textFilled]: !!a
              }),
              style: { height: T },
              "aria-disabled": e,
              "data-destructive": x === "destructive",
              maxLength: r,
              autoComplete: N,
              readOnly: w
            }
          )
        ] }),
        (l || s) && /* @__PURE__ */ t.jsx(
          k,
          {
            label: l,
            disabled: e,
            icon: s,
            tooltipText: F,
            status: x,
            withTextField: !0
          }
        )
      ]
    }
  );
};
export {
  P as default
};
//# sourceMappingURL=TextArea.js.map
